import './App.css'

const Footer = () => {
    return ( 
        <div id='footer'>
            <p className='footer_info'>
                <a id='linkedin' href="https://linkedin.com/in/LevNatekin">LinkedIn</a>
            </p>
            <p id='name'>Lev Natekin</p>
            <p className='footer_info'>
                <a id='github' href="https://github.com/D0odi">GitHub</a>
            </p>
        </div>
     );
}
 
export default Footer;